export const remToPx = (remValue: number) => {
  const rootFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  return remValue * rootFontSize;
};

export const pxToRem = (pxValue: number) => {
  const rootFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  return pxValue / rootFontSize;
};
